<template>
  <div class="login">
    <div class="logo">
      <img src="../assets/loginLogo.png" alt />
    </div>
    <div class="login_title">微观资讯后台管理系统</div>

    <div class="login_content">
      <div :class="user ? 'login_user' : 'new_user'">
        <el-input
          placeholder="用 户 名"
          v-model="formLabelAlign.name"
          @keyup.enter.native="
            formLabelAlign.name != '' ||
            (formLabelAlign.name && formLabelAlign.password)
              ? getPwd()
              : submit()
          "
        >
        </el-input>
      </div>
      <div class="login_pwd">
        <el-input
          placeholder="密      码"
          v-model="formLabelAlign.password"
          type="password"
          @keyup.enter.native="submit()"
        >
          <img
            src="../assets/loginBtn.png"
            alt
            slot="suffix"
            class="icon"
            @click="submit()"
          />
        </el-input>
      </div>
    </div>
    <div class="beian">
      <div>版权所有：微观要闻（天津）网络科技有限公司</div>
      <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank"
        >备案号：津ICP备20004302号-3</a
      >
    </div>
  </div>
</template>

<script>
import md5 from "js-md5";
export default {
  name: "Login",
  data() {
    return {
      user: true, //用户-回车-密码弹出
      //登录参数：
      formLabelAlign: {
        name: "",
        password: "",
      },
    };
  },
  methods: {
    //展示密码：
    getPwd() {
      this.user = false; //新的用户样式
      // document.querySelector(".login_user").className = "new_pwd";
    },
    //登录：
    submit() {
      var name = this.formLabelAlign.name;
      var password = this.formLabelAlign.password;
      if (name == "" || password == "") {
        alert("用户名和密码不能为空");
      } else {
        this.postAxios("/manager/login", {
          loginId: md5(name),
          pwd: md5(password),
        }).then((res) => {
          if (res.message == "操作成功") {
            this.$store.commit("getAdmin", res.entity.roleId);
            this.$store.commit("getName", res.entity.name);
            this.$store.commit("getMenu", res.entity.pageList);
            this.$store.commit("getPermission", res.entity.permissionList);
            this.$store.commit("getToken", res.entity.token);
            this.$router.push({ path: "/home" });
            localStorage.setItem("loginId", res.entity.loginId);
            localStorage.setItem("key", res.entity.token);
            localStorage.setItem("login", res.entity.roleId);
            localStorage.setItem("userId", res.entity.id);
            localStorage.setItem("phone", this.formLabelAlign.name);
            localStorage.setItem("areaCode", res.entity.areaCode);
          } else {
            // alert(res.message);
            this.$message.error(res.message);
          }
        });
      }
    },
  },
  created() {
    var that = this;
  },
};
</script>

<style scoped lang="less">
.login {
  width: 100%;
  height: 100%;
  background-image: url("../assets/loginBack.png");
  background-repeat: no-repeat;
  position: relative;
  background-size: 100% 100%;
  overflow: hidden;

  .logo {
    width: 196px;
    height: 54px;
    position: absolute;
    left: 55px;
    top: 43px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .login_title {
    width: 1051px;
    height: 94px;
    font-size: 60px;
    font-family: Alibaba PuHuiTi;
    font-weight: 400;
    color: #ffffff;
    line-height: 94px;

    position: absolute;
    left: 50%;
    margin-left: -525.5px;
    top: 30%;
    text-align: center;
    letter-spacing: 14px;
  }

  .login_content {
    width: 390px;
    height: 80px;

    border-radius: 6px;
    position: absolute;
    top: 45%;
    left: 50%;
    margin-left: -195px;

    .login_user {
      width: 390px;
      height: 40px;
      background: #ffffff;
      border-radius: 6px;
      position: absolute;
      top: 0%;
      left: 50%;
      margin-left: -195px;
      /deep/ .el-input {
        width: 100%;
        height: 100%;
        border: 0px;
        border-radius: 0px;
      }

      .icon {
        width: 20px;
        height: auto;
        position: absolute;
        right: 5px;
        top: 10px;
      }

      /deep/ .el-icon-loading {
        font-size: 30px;
        position: absolute;
        top: 5px;
        right: 3px;
      }
    }

    .new_user {
      width: 390px;
      height: 40px;
      background: #fff;

      position: absolute;
      top: 0%;
      left: 50%;
      margin-left: -195px;
      border-radius: 6px 6px 0px 0px;
      //     border-top-radius: 6px;

      // border-radius: 6px 6px 0px 0px;
      /deep/ .el-input {
        width: 100%;
        height: 100%;
        border: 0px;
        border-radius: 6px 6px 0px 0px;
      }

      .icon {
        width: 20px;
        height: auto;
        position: absolute;
        right: 5px;
        top: 10px;
      }

      /deep/ .el-icon-loading {
        font-size: 30px;
        position: absolute;
        top: 5px;
        right: 3px;
      }
    }
    .login_pwd {
      width: 390px;
      height: 40px;
      background: #ffffff;
      border-radius: 6px 6px 0px 0px;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-left: -195px;
      /deep/ .el-input {
        width: 100%;
        height: 100%;
        border: 0px;
        border-radius: 6px 6px 0px 0px;
      }

      .icon {
        width: 20px;
        height: auto;
        position: absolute;
        right: 5px;
        top: 10px;
      }
    }
  }
  .beian {
    color: #ffffff;
    position: relative;
    text-align: center;
    top: 95%;
  }
}
</style>
